function polar(cx, cy, r, angle) {
    const rad = ((angle - 90) * Math.PI) / 180;
    return {
        x: cx + r * Math.cos(rad),
        y: cy + r * Math.sin(rad)
    };
}

function donutPath(cx, cy, inner, outer, start, end) {
    const sweep = Math.min(Math.max(end - start, 0), 359.999);
    const large = sweep > 180 ? 1 : 0;
    const oStart = polar(cx, cy, outer, start);
    const oEnd = polar(cx, cy, outer, start + sweep);
    const iStart = polar(cx, cy, inner, start);
    const iEnd = polar(cx, cy, inner, start + sweep);
    return [
        `M ${oStart.x} ${oStart.y}`,
        `A ${outer} ${outer} 0 ${large} 1 ${oEnd.x} ${oEnd.y}`,
        `L ${iEnd.x} ${iEnd.y}`,
        `A ${inner} ${inner} 0 ${large} 0 ${iStart.x} ${iStart.y}`,
        'Z'
    ].join(' ');
}

function ProfitPieChart({ slices = [], centerTitle, centerValue, colorKey = [], emptyLabel = 'Sem dados para o gráfico' }) {
    const valid = (slices || []).filter(slice => Number(slice.value) > 0);
    const total = valid.reduce((sum, slice) => sum + Number(slice.value), 0);
    const size = 220;
    const cx = size / 2;
    const cy = size / 2;
    const outer = 92;
    const inner = 56;

    let angle = 0;
    const paths = valid.map((slice, index) => {
        const portion = (Number(slice.value) / total) * 360;
        const start = angle;
        angle += portion;
        return {
            ...slice,
            percent: (Number(slice.value) / total) * 100,
            d: donutPath(cx, cy, inner, outer, start, start + portion),
            key: slice.key || slice.label || index
        };
    });

    return (
        <div className="profit-pie">
            <div className="profit-pie-graphic">
                {total > 0 ? (
                    <svg viewBox={`0 0 ${size} ${size}`} width="220" height="220" role="img" aria-label={centerTitle || 'Gráfico de pizza'}>
                        {paths.map(slice => (
                            <path key={slice.key} d={slice.d} fill={slice.color} stroke="#1a1a1a" strokeWidth="2">
                                <title>{`${slice.label}: ${slice.percent.toFixed(0)}%`}</title>
                            </path>
                        ))}
                    </svg>
                ) : (
                    <div className="profit-pie-empty">{emptyLabel}</div>
                )}
                {total > 0 && (
                    <div className="profit-pie-center">
                        {centerTitle && <span>{centerTitle}</span>}
                        {centerValue && <strong>{centerValue}</strong>}
                    </div>
                )}
            </div>
            <div className="profit-pie-side">
                {colorKey.length > 0 && (
                    <div className="profit-pie-key">
                        {colorKey.map(item => (
                            <span key={item.label}>
                                <i style={{ background: item.color }} />
                                {item.label}
                            </span>
                        ))}
                    </div>
                )}
                <ul className="profit-pie-legend">
                    {valid.map(slice => (
                        <li key={slice.key || slice.label}>
                            <i style={{ background: slice.color }} />
                            <div>
                                <strong>{slice.label}</strong>
                                <span>{slice.caption || `${((Number(slice.value) / total) * 100).toFixed(0)}%`}</span>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default ProfitPieChart;
